import { BrowserRouter as Router } from "react-router-dom";
import { useState, useEffect } from "react";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import CookieConsent from "./components/CookieConsent/CookieConsent";
import ModalBoleto from "./components/Modal/ModalBoleto";
import ModalAviso from "./components/Modal/ModalAviso";
import AppRoutes from "./routes/AppRoutes";
import ScrollToTop from "./utils/scrollToTop";

function App() {
  const [showModalBoleto, setShowModalBoleto] = useState(false);
  const [showModalAviso, setShowModalAviso] = useState(false);

  useEffect(() => {
    // Mostrar ModalAviso na primeira renderização
    setShowModalAviso(true);
  }, []);

  useEffect(() => {
    // Mostrar ModalBoleto na primeira renderização
    setShowModalBoleto(true);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Header />
      <AppRoutes />
      <Footer />
      <CookieConsent />
      {/* ModalBoleto */}
      <ModalBoleto isOpen={showModalBoleto} onClose={() => setShowModalBoleto(false)} />
      {/* ModalAviso COMENTADO PARA USO FUTURO*/}
      {/*<ModalAviso isOpen={showModalAviso} onClose={() => setShowModalAviso(false)} />*/}
    </Router>
  );
}

export default App;